import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a Google Analytics 4 `page_view` event on every SPA route change.
 * gtag itself is loaded from index.html; we only send the event.
 */
export default function GAPageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    // Delay so the new route's <title> has been set by react-helmet-async
    const t = setTimeout(() => {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
}
